import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { WebSocketState } from '../types';

const initialState: WebSocketState = {
  isConnected: false,
  isConnecting: false,
  error: null,
  connectionId: null,
  lastPing: null,
};

const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    // Connection management
    connectStart: (state) => {
      state.isConnecting = true;
      state.error = null;
    },
    connectSuccess: (state, action: PayloadAction<{ connectionId: string }>) => {
      state.isConnected = true;
      state.isConnecting = false;
      state.connectionId = action.payload.connectionId;
      state.error = null;
    },
    connectFailure: (state, action: PayloadAction<string>) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.error = action.payload;
      state.connectionId = null;
    },
    disconnect: (state) => {
      state.isConnected = false;
      state.isConnecting = false;
      state.connectionId = null;
      state.error = null;
    },
    
    // Message handling - Enhanced for avatar integration
    messageReceived: (state, action: PayloadAction<{ type: string; data: any }>) => {
      const { type, data } = action.payload;
      console.log('WebSocket message received in slice:', { type, data });
      
      // This will be handled by other middleware (like avatar middleware)
      // Update last ping time for heartbeat
      state.lastPing = Date.now();
    },
    
    // Error handling
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    
    // Heartbeat
    updatePing: (state) => {
      state.lastPing = Date.now();
    },
  },
});

export const {
  connectStart,
  connectSuccess,
  connectFailure,
  disconnect,
  messageReceived,
  setError,
  clearError,
  updatePing,
} = websocketSlice.actions;

export default websocketSlice.reducer;